import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import { FiUpload } from "react-icons/fi";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
`;

const Modal = styled.div`
  background-color: #F1F1F1;
  border-radius: 12px;
  padding: 20px;
  width: auto;
  height: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  ${"" /* font-family: Arial, sans-serif; */}
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #888;
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
`;

const ModalContent = styled.div`
  height: calc(100% - 110px);
  overflow-y: auto;
`;

const ModalInput = styled.input`
  width: auto;
  margin-bottom: 10px;
  padding: 10px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ddd;
  box-sizing: border-box;
`;

const FileInput = styled.input`
  display: none;
`;

const FileInputLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
  background-color: #e75b82;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  transition: background-color 0.3s;

  &:hover {
    background-color: #005582;
  }
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ModalButton = styled.button`
  background-color: #e75b82;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #005582;
  }
`;

const SelectedImageContainer = styled.div`
  position: relative;
  margin-bottom: 5px;
  display: flex;
`;

const SelectedImage = styled.img`
  width: 150px;
  height: auto;
  margin: 20px 0;
  cursor: pointer;
`;

const CancelIcon = styled.span`
  position: absolute;
  font-size: 20px;
  cursor: pointer;
  color: #888;
  margin: 0 160px;
`;

const SelectedImage1 = styled.img`
  width: 100%;
  height: 80vh;
  cursor: pointer;
  @media (max-width: 767px) {
    height: auto;
  }
`;

const UpdateUserModal = ({ show, onClose, onSubmit, isFirst }) => {
  const [username, setUsername] = useState(localStorage.getItem("username"));
  const [profileImage, setProfileImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // useEffect(() => {
  //   setUsername(username || "");
  // }, [username]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Regular expression to allow only letters, numbers, and underscores
    const usernameRegex = /^[a-zA-Z0-9_\s]+$/;

    if (!usernameRegex.test(username)) {
      NotificationManager.warning(
        "Username can only contain letters, numbers, and underscores!",
        "Warning"
      );
      return;
    }

    if (username.trim().length === 0) {
      NotificationManager.warning(
        "Username must contain at least one character!",
        "Warning"
      );
      return;
    }

    const token = localStorage.getItem("token");
    const key = localStorage.getItem("user_key");
    const formData = new FormData();
    formData.append("key", key);
    formData.append("name", username);
    if (profileImage) {
      formData.append("profile_image", profileImage);
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/community-update`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === 200) {
        localStorage.setItem("profile_image", profileImage);
        localStorage.setItem("username", username);
        // console.log(response.data)
        onSubmit(username, profileImage);
        window.location.reload();
        handleClose();
      } else {
        NotificationManager.error(response.data.message, "Error");
      }
    } catch (error) {
      NotificationManager.error(
        "Error updating user! Please try again!",
        "Error"
      );
    }
    setLoading(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setProfileImage(file);
    setProfileImageUrl(URL.createObjectURL(file));
  };

  const handleClose = () => {
    setUsername(localStorage.getItem("username"));
    setProfileImage(null);
    setProfileImageUrl(null);
    setSelectedImageIndex(null);
    onClose();
  };

  const unselectImage = () => {
    setProfileImage(null);
    setProfileImageUrl(null);
  };

  const openImageModal = () => {
    setSelectedImageIndex(0);
  };

  const closeImageModal = () => {
    setSelectedImageIndex(null);
  };

  if (!show) {
    return null;
  }

  return (
    <ModalOverlay>
      {loading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      <Modal>
        <ModalHeader>
          <ModalTitle>{isFirst ? "Enter details" : "Update User"}</ModalTitle>
          <CloseButton onClick={handleClose}>×</CloseButton>
        </ModalHeader>
        <ModalContent>
          <ModalInput
            type="text"
            placeholder="Enter name"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          {!isFirst && (
            <FileInput
              id="fileInput"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
          )}
          {profileImageUrl && (
            <SelectedImageContainer>
              <SelectedImage
                src={profileImageUrl}
                alt="Selected Profile Image"
                onClick={openImageModal}
              />
              <CancelIcon onClick={unselectImage}>×</CancelIcon>
            </SelectedImageContainer>
          )}
        </ModalContent>
        <ModalActions>
          {!isFirst && (
            <ModalButton
              onClick={() => document.getElementById("fileInput").click()}
              style={{ marginRight: 10 }}
            >
              <FiUpload size={24}/>
            </ModalButton>
          )}
          <ModalButton onClick={handleSubmit}>{isFirst ? 'Submit':'Update'}</ModalButton>
        </ModalActions>
      </Modal>
      {selectedImageIndex !== null && (
        <ModalOverlay onClick={closeImageModal}>
          <Modal>
            <ModalContent>
              <SelectedImage1
                src={profileImageUrl}
                alt="Selected Profile Image"
              />
            </ModalContent>
          </Modal>
        </ModalOverlay>
      )}
      <NotificationContainer />
    </ModalOverlay>
  );
};

export default UpdateUserModal;
